export class TrafficConfigApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = 'TrafficConfigApiError';
  }
}
